import React from 'react';
import { RxCross2 } from 'react-icons/rx';
import { MdOutlineArrowDropDown } from 'react-icons/md';
import './DropdownSelectButton.css';

/**
 * DropdownSelectButton — CityDropdownForTrip jaisa exact UI
 *
 * Props:
 * @param {string}   label           - floating label (e.g. "Branch", "Driver")
 * @param {string}   selectTxt       - selected value label
 * @param {string}   placeholder     - placeholder when nothing selected
 * @param {function} onClick         - trigger click → open modal
 * @param {boolean}  crossIcon       - show clear + edit icons when value selected
 * @param {function} crossIconOnlick - clear handler
 * @param {function} onEditClick     - edit icon click
 * @param {boolean}  error           - red border
 * @param {string}   errorMessage    - error text below
 * @param {boolean}  disabled        - disabled state
 */
const DropdownSelectButton = ({
    label = '',
    selectTxt = '',
    placeholder = '',
    onClick,
    crossIcon,
    crossIconOnlick,
    onEditClick,
    error = false,
    errorMessage = '',
    disabled = false,
}) => {
    const hasValue = !!selectTxt && selectTxt !== placeholder;

    const handleClear = (e) => {
        e.stopPropagation();
        if (crossIconOnlick) crossIconOnlick();
    };

    const handleEdit = (e) => {
        e.stopPropagation();
        if (onEditClick) onEditClick();
    };

    return (
        <div style={{ position: 'relative', width: '100%' }}>

            {/* ── Trigger Box — same as .__anvCityDropNw ── */}
            <div
                className={`__anvCityDropNw __dropSelBtn_wrap ${error ? '__errorDv' : ''} ${disabled ? '__disabledDv' : ''}`}
                onClick={() => !disabled && onClick && onClick()}
            >
                {/* Floating Label */}
                {label && (
                    <label
                        style={{
                            position: 'absolute',
                            top: hasValue ? 0 : error ? '48%' : '50%',
                            left: 6,
                            fontSize: hasValue ? 12 : 14,
                            color: '#666',
                            background: disabled
                                ? hasValue ? '#fff' : '#f2f2f2'
                                : '#fff',
                            padding: hasValue ? '0 4px' : '0 100px 0px 5px',
                            transform: 'translateY(-50%)',
                            transition: 'all 0.2s ease',
                            pointerEvents: 'none',
                        }}
                    >
                        {label}
                    </label>
                )}

                {/* Selected Value / Placeholder */}
                <span
                    style={{
                        color: hasValue ? '#000' : '#888',
                        fontSize: 14,
                        flex: 1,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        paddingRight: '8px',
                        maxWidth: '188px',
                    }}
                >
                    {hasValue ? selectTxt : placeholder}
                </span>

                {/* Clear icon — value hone par */}
                

                {/* Right icons: arrow + divider + edit — same as CityDropdownForTrip */}
                <span className="_cty_trigger_icons">

                    {crossIcon && !disabled && (
                    <span className="clear-icon" onClick={handleClear}>
                        <RxCross2 size={18} color="black" />
                    </span>
                )}
                    <span className="_cty_caret" style={{ display: 'flex', alignItems: 'center' }}>
                        <MdOutlineArrowDropDown size={22} />
                    </span>

                    {/* Edit icon — sirf jab value selected ho aur onEditClick prop diya ho */}
                    {crossIcon && onEditClick && (
                        <>
                            <span className="_cty_icon_divider" />
                            <span className="_cty_edit_icon" onClick={handleEdit} title="Edit">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="14"
                                    height="14"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                >
                                    <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
                                    <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
                                </svg>
                            </span>
                        </>
                    )}
                </span>
            </div>

            {/* Error Message */}
            {error && errorMessage && (
                <div style={{ color: 'var(--invailid-color)', fontSize: 12, marginLeft: 3, marginTop: 3, fontWeight: 500 }}>
                    {errorMessage}
                </div>
            )}
        </div>
    );
};

export default DropdownSelectButton;